jQuery(document).ready(function ($) {
  $(window).on("load", function () {
    $(".pfr-preloader").delay(400).fadeOut("slow");
  });
  $(".mobile-menu-btn").on("click", function () {
    $("#mobile-flyout-menu").removeClass("hidden");
    setTimeout(function () {
      $("#flyout-panel").removeClass("-translate-x-full");
    }, 10);
  });

  $("#close-flyout, #mobile-flyout-menu").on("click", function (e) {
    if (
      e.target.id === "mobile-flyout-menu" ||
      $(e.target).closest("#close-flyout").length
    ) {
      $("#flyout-panel").addClass("-translate-x-full");
      setTimeout(function () {
        $("#mobile-flyout-menu").addClass("hidden");
      }, 300);
    }
  });

  $("#flyout-panel").on("click", function (e) {
    e.stopPropagation();
  });
  $("#flyout-panel").on("click", "a", function (e) {
    console.log("Link clicked:", $(this).attr("href"));
  });

  // Handle button clicks for submenu toggles
  $("#flyout-panel").on("click", "button, span", function (e) {
    var $element = $(this);
    var $li = $element.closest("li.toggle-submenu");
    var target = $li.data("target");

    if (target && $li.length) {
      e.preventDefault();
      e.stopPropagation();

      var $arrow = $li.find("button svg").first();
      var $submenu = $("#" + target);
      var isCurrentlyOpen = $submenu.is(":visible");
      // Close other open submenus
      $li.siblings("li[data-target]").each(function () {
        var siblingTarget = $(this).data("target");
        if (siblingTarget) {
          $("#" + siblingTarget).slideUp(200);
          $(this).find("button svg").first().removeClass("rotate-180");
        }
      });

      // Toggle current submenu
      if (isCurrentlyOpen) {
        $submenu.slideUp(200);
        $arrow.removeClass("rotate-180");
      } else {
        $submenu.slideDown(200);
        $arrow.addClass("rotate-180");
      }
    }
  });

  // Toggle submenu visibility Ends

  // Testimonial Slider Starts
  if (window.$ && $(".testimonial-slider").length) {
    $(".testimonial-slider").slick({
      arrows: true,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        '<svg class="w-12 h-12 lg:w-16 lg:h-16 absolute left-[calc(50%-80px)] lg:left-0 top-full lg:top-[calc(50%-60px)] text-white cursor-pointer" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 48 48"><line x1="32" y1="8" x2="16" y2="24" /><line x1="16" y1="24" x2="32" y2="40" /></svg>',
      nextArrow:
        '<svg class="w-12 h-12 lg:w-16 lg:h-16 absolute right-[calc(50%-80px)] lg:right-0 top-full lg:top-[calc(50%-60px)] text-white cursor-pointer " fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 48 48"><line x1="16" y1="8" x2="32" y2="24" /><line x1="32" y1="24" x2="16" y2="40" /></svg>',
      adaptiveHeight: true,
    });
  }

  if (window.$ && $(".gift-card__images").length) {
    $(".gift-card__images").slick({
      dots: true,
    });
  }

  // Tab switching
  $(".faq-tab-btn").on("click", function () {
    var tabIdx = $(this).data("tab");
    $(".faq-tab-btn")
      .removeClass("bg-brandPrimary text-white active")
      .addClass("bg-gray-100 text-gray-700");
    $(this)
      .addClass("bg-brandPrimary text-white active")
      .removeClass("bg-gray-100 text-gray-700");
    $(".faq-tab-content").addClass("hidden");
    $('.faq-tab-content[data-tab-content="' + tabIdx + '"]').removeClass(
      "hidden",
    );
  });
  // FAQ accordion
  $(".faq-question").on("click", function () {
    var $answer = $(this).closest(".border-b").find(".faq-answer");
    $answer.toggleClass("hidden");
    $(this).find("svg").toggleClass("rotate-180");
  });

  // Info Tab
  const $tabLinks = $(".tab-link");
  const $tabContents = $(".tabs-content");
  const $certificateImages = $(".certificate-img");

  $tabLinks.on("click", function (e) {
    e.preventDefault();
    const targetTab = $(this).data("tab");

    $tabLinks
      .removeClass("border border-brandPrimary bg-gray-100")
      .addClass("bg-white text-gray-800");

    $(this)
      .addClass("border border-brandPrimary  bg-gray-100")
      .removeClass("bg-white text-gray-800");

    $tabContents.addClass("hidden");

    $("#tabs-" + targetTab).removeClass("hidden");
    $certificateImages.addClass("hidden");

    $certificateImages
      .filter('[data-tab="' + targetTab + '"]')
      .removeClass("hidden");
  });

  // Store Scripts Starts

  if ($("#store-locator-data").length > 0) {
    let storeData = [];
    try {
      const storeDataEl = document.getElementById("store-locator-data");
      if (
        storeDataEl &&
        storeDataEl.textContent &&
        storeDataEl.textContent.trim() !== ""
      ) {
        const parsed = JSON.parse(storeDataEl.textContent);
        // Defensive extraction in case structure differs
        storeData =
          Array.isArray(parsed) && parsed[0] && parsed[0].store_data
            ? parsed[0].store_data
            : [];
      } else {
        console.warn(
          "No #store-locator-data element or empty content — using empty storeData",
        );
        storeData = [];
      }
    } catch (error) {
      console.error("Error loading store data:", error);
      storeData = [];
    }

    // Initialize DataTable

    const table = $("#stores-table").DataTable({
      data: storeData,
      pageLength: 100,
      lengthMenu: [
        [25, 50, 100, 200, -1],
        [25, 50, 100, 200, "All"],
      ],
      order: [
        [0, "asc"],
        [1, "asc"],
      ], // Sort by state, then store name
      columns: [
        {
          data: "state",
          title: "State",
          width: "20%",
          render: function (data) {
            return data || '<span class="text-gray-400 italic">No State</span>';
          },
        },
        {
          data: "store",
          title: "Store Name",
          width: "80%",
          render: function (data) {
            return (
              data || '<span class="text-gray-400 italic">No Store Name</span>'
            );
          },
        },
      ],
      responsive: true,
      searching: true,
      language: {
        search: "Search all stores:",
        lengthMenu: "Show _MENU_ stores per page",
        info: "Showing _START_ to _END_ of _TOTAL_ stores",
        infoEmpty: "No stores found",
        infoFiltered: "(filtered from _MAX_ total stores)",
        zeroRecords: "No stores match your search criteria",
        emptyTable: "No store data available",
      },
      dom: '<"flex flex-col p-2 lg:flex-row lg:justify-between lg:items-center mb-4"<"mb-2 lg:mb-0"l><"mb-2 lg:mb-0"f>>rtip',
      initComplete: function () {
        // Add a small delay to ensure DataTables is fully initialized
        setTimeout(function () {
          updateStoreCount();
          // Style the DataTables elements with Tailwind
          styleDataTableElements();
        }, 100);
      },
    });

    // Initial store count update (fallback)
    if (storeData.length > 0) {
      $("#data-info span:last-child").text(`${storeData.length} stores`);
    }

    // State filter functionality
    $("#state-filter").on("change", function () {
      const selectedState = $(this).val();

      if (selectedState === "") {
        table.columns(0).search("").draw();
      } else {
        table
          .columns(0)
          .search("^" + selectedState + "$", true, false)
          .draw();
      }

      updateStoreCount();
      updateMapHighlight(selectedState);
    });

    // Clear filters
    $("#clear-filters").on("click", function () {
      $("#state-filter").val("");
      table.search("").columns().search("").draw();
      updateStoreCount();
      updateMapHighlight("");
    });

    // Update store count display
    function updateStoreCount() {
      try {
        const info = table.page.info();
        const filteredCount = info.recordsDisplay;
        const totalCount = info.recordsTotal;

        let countText = `${totalCount} stores`;
        if (filteredCount !== totalCount) {
          countText = `${filteredCount} of ${totalCount} stores`;
        }

        $("#data-info span:last-child").text(countText);
      } catch (error) {
        console.error("Error updating store count:", error);
        $("#data-info span:last-child").text("Error loading count");
      }
    }

    // Update table info when search/filter changes
    table.on("draw", function () {
      updateStoreCount();
    });

    // Map highlighting function
    function updateMapHighlight(stateId) {
      $("#store-locator-map__svg path,#store-locator-map__svg rect").css(
        "fill",
        "#fff",
      );

      if (stateId) {
        $(".sm_" + stateId + ", .sm_state_" + stateId).css("fill", "#ed2129");
      }
    }

    // Global filter function for external use (e.g., map clicks)
    window.filterGlobal = function (stateCode) {
      $("#state-filter").val(stateCode).trigger("change");

      // Scroll to table
      $("html, body").animate(
        {
          scrollTop: $("#stores-table").offset().top - 100,
        },
        500,
      );
    };

    // Style DataTables elements
    function styleDataTableElements() {
      $(".dataTables_filter input").addClass(
        "ml-2 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
      );
      $(".dataTables_filter label").addClass(
        "text-sm font-medium text-gray-700",
      );

      $(".dataTables_length select").addClass(
        "ml-2 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
      );
      $(".dataTables_length label").addClass(
        "text-sm font-medium text-gray-700",
      );

      $(".dataTables_paginate .paginate_button").addClass(
        "px-3 py-2 ml-1 text-sm text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:text-gray-700",
      );
      $(".dataTables_paginate .paginate_button.current").addClass(
        "bg-blue-500 text-white border-blue-500 hover:bg-blue-600",
      );
      $(".dataTables_paginate .paginate_button.disabled").addClass(
        "text-gray-300 cursor-not-allowed hover:bg-white hover:text-gray-300",
      );

      // Style info text
      $(".dataTables_info").addClass("text-sm text-gray-700");

      // Style table rows
      $("#stores-table tbody tr").addClass("hover:bg-gray-50");
      $("#stores-table tbody td").addClass(
        "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
      );
    }

    jQuery("svg a").click(function (e) {
      e.preventDefault();
    });
  }

  // Store Scripts Ends

  window.scrollToAnchor = function (aid) {
    const target = $(`p[name='${aid}']`);
    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top,
        },
        500,
      );
    }
  };

  // Order Handelling
  function populateProvince(select) {
    var selectedCountryOption = null;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === select.getAttribute("value")) {
        selectedCountryOption = select.options[i];
        selectedCountryOption.setAttribute("selected", "selected");
        break;
      }
    }
    if (!selectedCountryOption)
      selectedCountryOption = select.options[select.selectedIndex];

    if (!selectedCountryOption) return;

    try {
      var provincesData =
        selectedCountryOption.dataset.provinces ||
        selectedCountryOption.getAttribute("data-provinces") ||
        "[]";
      var provinces = JSON.parse(provincesData);
    } catch (e) {
      var provinces = [];
    }

    var id = select.dataset.id;
    var provinceSelector = document.querySelector("#address_province_" + id);
    if (!provinceSelector) return;

    if (!provinces || provinces.length === 0) {
      provinceSelector.setAttribute("disabled", "disabled");
      provinceSelector.innerHTML = "";
      return;
    }

    provinceSelector.removeAttribute("disabled");
    var options = "";
    for (var j = 0; j < provinces.length; j++) {
      var value = provinces[j][0];
      var label = provinces[j][0];
      var selected = "";
      if (provinceSelector.getAttribute("value") === value)
        selected = " selected";
      options +=
        '<option value="' + value + '"' + selected + ">" + label + "</option>";
    }
    provinceSelector.innerHTML = options;
  }

  function initCountryProvince() {
    var all = document.querySelectorAll("select[data-country-selector]");
    if (!all || all.length === 0) return;
    for (var i = 0; i < all.length; i++) {
      populateProvince(all[i]);
      (function (sel) {
        sel.addEventListener("change", function () {
          populateProvince(this);
        });
      })(all[i]);
    }
  }

  function bindUI() {
    var newBtn = document.getElementById("new-address-btn");
    var newModal = document.getElementById("new-address-modal");
    var closeNew = document.getElementById("close-new-address");
    var cancelNew = document.getElementById("cancel-new-address");

    function open(el) {
      if (el) el.classList.remove("hidden");
    }
    function close(el) {
      if (el) el.classList.add("hidden");
    }

    if (newBtn)
      newBtn.addEventListener("click", function () {
        open(newModal);
      });
    if (closeNew)
      closeNew.addEventListener("click", function () {
        close(newModal);
      });
    if (cancelNew)
      cancelNew.addEventListener("click", function () {
        close(newModal);
      });

    // edit buttons
    var editBtns = document.querySelectorAll(".edit-address-btn");
    editBtns.forEach(function (btn) {
      var id = btn.dataset.addressId;
      btn.addEventListener("click", function () {
        var modal = document.getElementById("edit-address-" + id);
        if (modal) modal.classList.remove("hidden");
        // populate provinces for this modal (in case)
        var countrySelect = document.querySelector("#address_country_" + id);
        if (countrySelect) populateProvince(countrySelect);
      });
    });

    // close edit modals
    var closeEditBtns = document.querySelectorAll(".close-edit-address");
    closeEditBtns.forEach(function (btn) {
      var id = btn.dataset.addressId;
      btn.addEventListener("click", function () {
        var modal = document.getElementById("edit-address-" + id);
        if (modal) modal.classList.add("hidden");
      });
    });

    // delete buttons
    var deleteBtns = document.querySelectorAll(".delete-address-btn");
    deleteBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var url = this.dataset.url;
        if (confirm("Do you really wish to delete this address?")) {
          // submit the hidden form next to the card
          var form = this.parentElement.querySelector(
            "form.delete-address-form",
          );
          if (form) {
            form.action = url;
            form.submit();
          } else {
            // fallback find by action
            var f = document.querySelector('form[action="' + url + '"]');
            if (f) f.submit();
          }
        }
      });
    });
  }

  // prefer jQuery ready if available
  if (window.jQuery) {
    (function ($) {
      $(function () {
        initCountryProvince();
        bindUI();
      });
    })(jQuery);
  } else {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        initCountryProvince();
        bindUI();
      });
    } else {
      initCountryProvince();
      bindUI();
    }
  }

  // Initialize the cart update functionality

  function initCartUpdates() {
    $(document).on("input change", 'input[name="updates[]"]', function (e) {
      const $input = $(this);
      let timeoutId = $input.data("timeout-id");

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const newQuantity = parseInt($input.val());
      if (newQuantity < 1) {
        $input.val(1);
        return;
      }
      const delay = e.type === "input" ? 1000 : 0;
      timeoutId = setTimeout(function () {
        updateCartQuantity();
      }, delay);

      $input.data("timeout-id", timeoutId);
    });
  }

  function updateCartQuantity() {
    const $form = $("#cart-form");
    const $checkoutBtn = $("#checkout-btn");

    if (!$form.length || !$checkoutBtn.length) {
      console.error("Cart form or checkout button not found");
      return;
    }

    const originalBtnText = $checkoutBtn.text();

    // Show loading state
    $checkoutBtn.text("UPDATING CART...").prop("disabled", true);

    // Get form data
    const formData = $form.serialize();

    // Use jQuery AJAX instead of fetch for better compatibility
    $.ajax({
      url: "/cart/update.js",
      method: "POST",
      data: formData,
      dataType: "json",
      timeout: 10000, // 10 second timeout
      success: function (cart) {
        console.log("Cart updated successfully:", cart);
        // Reload page to show updated totals
        window.location.reload();
      },
      error: function (xhr, status, error) {
        console.error("Cart update failed:", {
          status: status,
          error: error,
          response: xhr.responseText,
        });

        // Restore button state
        $checkoutBtn.text(originalBtnText).prop("disabled", false);

        // More specific error messages
        let errorMessage = "Failed to update cart. Please try again.";

        if (status === "timeout") {
          errorMessage =
            "Request timed out. Please check your connection and try again.";
        } else if (xhr.status === 422) {
          errorMessage =
            "Invalid cart data. Please refresh the page and try again.";
        } else if (xhr.status >= 500) {
          errorMessage = "Server error. Please try again in a moment.";
        }

        // Show user-friendly error
        if (
          window.confirm(
            errorMessage + "\n\nWould you like to refresh the page?",
          )
        ) {
          window.location.reload();
        }
      },
      complete: function () {
        // This runs regardless of success/error
        console.log("Cart update request completed");
      },
    });
  }

  // Initialize cart updates
  initCartUpdates();
});
